<template>
    <div class="modal-wrapper" :class="{ hide: !modals.confirmEmail }">
        <div class="modal">
            <div class="title-wrapper">
                <BaseModalTitle>
                    <template #left>
                        <div class="modal-title-left">
                            <i class="material-symbols-outlined">notification_multiple</i>
                            <span class="title__medium">Almost there!</span>
                        </div>
                    </template>
                    <template #right>
                        <BaseButtonSmall
                            :buttonText="tokens.loginModal.login"
                            :buttonStyle="'tonal-secondary'" 
                            @click.native="goToLoginPage"
                        />
                    </template>
                </BaseModalTitle>
            </div>
            <div class="modal-box">
                <span class="title__medium">We've sent a confirmation link to</span>
                <span class="body__large">{{ email }}</span>
                <span class="title__medium">Please check your inbox and click the link to verify your email</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import BaseModalTitle from "@/new-design/shared/ui/titles/BaseModalTitle.vue"
import BaseButtonSmall from "@/new-design/shared/ui/buttons/BaseButtonSmall.vue"

export default {
    name: "TwoFactorAuthenticationModal",
    components: {BaseModalTitle, BaseButtonSmall},
    data() {
        return{
            email: ''  
        }
    },
    methods: {
        goToLoginPage() {
            window.location.href = '/';
        },
    },
    computed: {
        ...mapGetters(['tokens', 'modals'])
    },
    watch:{
        modals:{
            deep: true,
            handler(newVal){
                if(newVal.confirmEmail){
                    this.email = localStorage.getItem('userRegisterEmail');
                    localStorage.removeItem('userRegisterEmail');
                }
            }
        }
    }
}
</script>

<style scoped>
.new-design.mobile.banner-is-active .modal-wrapper {
    height: calc(100% - 44px);
}

.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    top: auto;
}

.modal {
    width: 620px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 25px 28px;
    z-index: 1100;
    border-radius: 8px;
    border: 1px solid var(--System-OutlineVariant);
    background: var(--System-Surface1);
    position: relative;
}

.title-wrapper {
    margin-bottom: 28px;
}

.modal-title-left {
    color: var(--System-OnSurface);
    display: flex;
    align-items: center;
    gap: 12px;
}

.modal-title-left i {
    font-size: 18px;
}

.modal-box {
    display: flex;
    flex-direction: column;
    gap: 0px;
    span{
        color: var(--System-OnSurfaceVariant);
        &:nth-child(2){
            color: var(--System-OnSurface);
        }
    }
    & span:last-child{
        margin-top: 20px;
    }
}

.modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.modal-goback{
    display: flex;
    align-items: center;
    gap: 10px;
}

@media(max-width: 768px){
    .modal{
        margin: 15px;
    }
}
</style>
